@if (open()) {
  <div class="whats-new-backdrop" (click)="close()"></div>
  <div class="whats-new" role="dialog" aria-modal="true" aria-labelledby="whatsNewTitle">
    <!-- only the text scrolls, the buttons stay visible below it -->
    <div class="content">
    <h2 id="whatsNewTitle" class="title">Das Wirtshaus hat sich herausgeputzt</h2>
    <p class="intro">Wir haben schnapsen.online aufgefrischt. Die Regeln und deine Punkte bleiben, wie sie sind.</p>

    <ul class="news">
      <li>
        <i class="fas fa-hourglass-half" aria-hidden="true"></i>
        <span><strong>„Dein Zug“</strong> unten rechts zeigt dir, wie viel Zeit du noch hast. Bei den Mitspielern läuft ein Ring um das Profilbild.</span>
      </li>
      <li>
        <i class="fas fa-table-cells-large" aria-hidden="true"></i>
        <span><strong>Neue Knöpfe und Sprechblasen</strong> am Tisch, gut lesbar am Computer und am Handy.</span>
      </li>
      <li>
        <i class="fas fa-clone" aria-hidden="true"></i>
        <span><strong>Neue doppeldeutsche Karten:</strong> frisch gezeichnet und gestochen scharf, auch am Handy.</span>
      </li>
      <li>
        <i class="fas fa-moon" aria-hidden="true"></i>
        <span><strong>Dunkler Modus:</strong> schont abends die Augen. Er folgt deinem Gerät, oder du stellst ihn unter <a routerLink="/mein-profil/einstellungen" (click)="close()">Einstellungen</a> fix auf Hell oder Dunkel.</span>
      </li>
      <li>
        <i class="fas fa-house" aria-hidden="true"></i>
        <span><strong>Aufgeräumte Seiten:</strong> Dashboard, Rangliste, Profil und Community sind übersichtlicher.</span>
      </li>
      <li>
        <i class="fas fa-crown" aria-hidden="true"></i>
        <span><strong>Neu: das Stammtisch-Abo.</strong> Der Tisch ist neu, und mit dem Abo gestaltest du ihn dir selbst. Damit bleibt Schnapsen für alle kostenlos und werbefrei.</span>
      </li>
    </ul>

    <p class="legal-note">
      Mit dem Abo haben wir auch die <a routerLink="/agb" (click)="close()">AGB</a> und die
      <a routerLink="/datenschutz" (click)="close()">Datenschutzerklärung</a> überarbeitet. Für das
      kostenlose Spiel ändert sich für dich nichts Wesentliches.
    </p>
    </div>

    <div class="actions">
      <a uiButton="outline" routerLink="/premium" (click)="close()">Zum Stammtisch-Abo</a>
      <button type="button" uiButton (click)="close()">Los geht's</button>
    </div>
  </div>
}
